<template>
  <v-container>
    <v-layout>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card class="login-dialog">
          <v-card-title
            justify-center
            class="justify-center headline purple--text title font-weight-bold"
          >Login</v-card-title>
          <v-form ref="form" lazy-validation>
            <v-card-text>
              <v-text-field
                box
                required
                v-model="email"
                :rules="rules.emailRules"
                color="purple"
                label="E-mail"
                name="email"
                placeholder="Enter your email"
              ></v-text-field>
              <v-text-field
                box
                v-model="password"
                :rules="rules.passRules"
                color="purple"
                label="Password"
                min="8"
                :type="isPasswordVisible ? 'text' : 'password'"
                placeholder="Enter your password"
              >
                <template slot="append">
                  <div @click="changeVal('isPasswordVisible')">
                    <span v-if="!isPasswordVisible">Show</span>
                    <span v-else>Hide</span>
                  </div>
                </template>
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-layout align-center justify-center>
                <v-btn dark color="purple" @click.prevent="submit">login</v-btn>
              </v-layout>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
    <showModal
      v-model="showDialog"
      :message="dialogMessage"
      :header="dialogHeader"
      :buttonText="dialogButtonText"
    ></showModal>
  </v-container>
</template>
<script>
// import Vue from "vue";
// import VeeValidate from "vee-validate";
import axios from "axios";
import showModal from "@/components/ShowModal";

export default {
  name: "login",
  components: {
    showModal
  },
  data: () => ({
    dialog: true,
    showDialog: false,
    dialogMessage: "",
    dialogHeader: "",
    dialogButtonText: "",
    email: "",
    password: "",
    isPasswordVisible: false,
    rules: {
      passRules: [
        value => !!value || "Password is required",
        value =>
          (value && value.length >= 8) ||
          "Password must be longer than 8 characters"
      ],
      emailRules: [
        value => !!value || "E-mail is required",
        value => /.+@.+/.test(value) || "E-mail must be valid"
      ]
    }
  }),
  methods: {
    changeVal(value) {
      this[value] = !this[value];
    },
    submit() {
      if (this.$refs.form.validate()) {
        // alert('validation passed')
        // this.$router.push('/devices')
        axios
          .post(this.$hostname + "/admin/login", {
            email: this.email,
            password: this.password
          })
          .then(response => {
            console.log(response);
            if (response.status === 200) {
              localStorage.setItem("token", response.data.data.token);
              localStorage.setItem("role", response.data.data.role);

              // this.showDialog = true
              if (localStorage.getItem("role") === '0') {
                (this.showDialog = true),
                  (this.dialogMessage = `This website is not available for you`);
              } else {
                this.$router.push("/devices");
              }
            }
          })
          .catch(error => {
            (this.showDialog = true),
              (this.dialogMessage = `${this.$store.getters.errorsList[error.response.data.message]}`);
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
